// extracted by mini-css-extract-plugin
export default {"impCard":"service_impCard__K+RNX","tblHead":"service_tblHead__UAnv0","tblBody":"service_tblBody__v6AuE","tabContainer":"service_tabContainer__kqwdW"};